<template>
    <nav class="inline-flex rounded-lg border border-gray-200 bg-gray-100 p-1">
        <RouterLink
            v-for="tab in tabs"
            :key="tab.routeName"
            :to="{ name: tab.routeName }"
            :aria-current="tab.routeName === activeRouteName ? 'page' : undefined"
            :class="[
                'inline-flex items-center gap-x-1.5 rounded-md py-1.5 px-3 text-sm font-medium transition-colors',
                tab.routeName === activeRouteName ? 'bg-white text-primary-800 shadow-sm ring-1 ring-gray-200' : 'text-gray-500 hover:text-gray-700',
            ]"
        >
            <component :is="tab.icon" class="h-4 w-4" aria-hidden="true" />
            {{ $t(tab.labelKey) }}
        </RouterLink>
    </nav>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { Gauge, History } from 'lucide-vue-next';

const route = useRoute();

const tabs = [
    { routeName: 'DataQuality', labelKey: 'views.dataQuality.viewSwitch.current', icon: Gauge },
    { routeName: 'DataQualityHistory', labelKey: 'views.dataQuality.viewSwitch.history', icon: History },
];

const activeRouteName = computed(() => route.name);
</script>
